import React from 'react';
import Box from '@material-ui/core/Box';

const TabPanel = ({ value, index, children }) => {
  
  if (value !== index) return null;
  else return (
    <>
      { children }
    </>
  )
}

export default TabPanel;